const Filter = (props) => (
  <svg width='16' height='10' viewBox='0 0 16 10' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect width='16' height='2' fill='#596D79' />
    <rect x='3' y='4' width='10' height='2' fill='#596D79' />
    <rect x='6' y='8' width='4' height='2' fill='#596D79' />
  </svg>
);

export default Filter;
